import React, { useState, useEffect, useRef } from "react";
import { Card, Button, CardBody, Col, Container, Form, Input, Label, Row, FormFeedback, CardFooter } from "reactstrap";
import { useFormik } from "formik";

import "../../../../node_modules/@vtaits/react-color-picker/dist/index.css";
import "react-datepicker/dist/react-datepicker.css";
import * as url from "../../../../src/helpers/url_helper";
import Select from "react-select";
import * as Yup from "yup";
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//Import Breadcrumb
import axios from "axios";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper"
import * as constants from "../../../constants/layout"
import PublishModal from "../../../components/Common/PublishModal";
import Spinners from "../../../components/Common/Spinner";


import "./conf.scss"
const CreateSubscription = () => {

    const { spid } = useParams();


    const user = getLoggedInUser()
    const navigate = useNavigate();

    const [isLoading, setLoading] = useState(false);
    const [plan, setPlan] = useState(null);
    const [masterList, setmasterList] = useState([]);
    const [editdata, seteditdata] = useState([]);
    const [plancategory, setPlanCategory] = useState([]);
    const [allBoardcategory, setAllBoardcategory] = useState([]);
    const [noOfQuestions, setNoOfQuestions] = useState('');
    const [markPerQuestion, setMarkPerQuestion] = useState('');
    const [subject, setsubject] = useState([]);
    const [submitbtn, setSubmitbtn] = useState(false);
    const [initialSubmitState, setInitialSubmitState] = useState(false);
    const [isTestSeries, setIsTestSeries] = useState(false);
    var isPlanClone = localStorage.getItem('isPlanClone');



    const [totalquestions, setTotalQuestions] = useState([]);
    
    const [marks, setMarks] = useState(false);
    const [status, setstatus] = useState(true);
    const [publishStatus, setPublishStatus] = useState(false);
    const [editPublishStatus, setEditPublishStatus] = useState(false);
    const confref = useRef(null);
    const [inputFocus, setInputFocus] = useState(false);

    const [ selectedTotalQuestions, setSelectedTotalQuestions ] = useState(null);
    const [subscriptionCount,setSubscriptionCount] = useState(0);
    const [publishModal, setPublishModal] = useState(false);
    const [publishContent,setPublishContent] = useState();
    useEffect(() => {

        if (handleClose) {
            setInputFocus(false);
        } else {
            setInputFocus(true)
        }

    }, [])

    useEffect(() => {
     
      if(selectedTotalQuestions && marks){
      
        var totalMarks = selectedTotalQuestions?.label * marks
        validation.setFieldValue("totalMarks", totalMarks);
        
      }

    }, [selectedTotalQuestions, marks])


    const handleClose = () => {
        validation.resetForm();
        setInitialSubmitState(true);
        navigate("/list-subscriptionplan");
    }

    // const handleSelectTotalMarks = (selectedOption) => {
    //     // const totalQuestionsValue = selectedOption?.label; // Adjust this based on your value structure
    //     validation.setFieldValue("totalQuestions", selectedOption);
    // };







    useEffect(() => {

        document.getElementById('headerTitle').innerHTML = 'Create Subscription';
        editLoadPlan(spid)
    }, [spid]);






    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            planID: (plan && plan.planID) || "",
            planName: (plan && plan.planName) || "",
            totalMarks: (plan && plan.totalMarks) || "",
            amount: (plan && plan.amount) || "",
            validity: (plan && plan.validity) || "",
            marks: (plan && plan.marks) || "",

            totalTests: (plan && plan.totalTests) || null,
            duration: (plan && plan.duration) || "",
            selectedPlanCategory: (plan && plan.selectedPlanCategory?.value) || null,
            selectedTotalQuestions: (plan && plan.selectedTotalQuestions?.value) || null,


        },
        validationSchema: Yup.object({
            planName: Yup.string().required("Please Enter Configuration Name"),
            totalMarks: Yup.number().required("Please Enter Total Marks"), 
            amount: Yup.number().required("Please Enter Amount"),
            validity: Yup.number().required("Please Enter Validity"),
            marks: Yup.number().when('selectedPlanCategory', {
                is:  (val) => val?.value === constants.subscriptionCategory.subjectwise, 
                then: (schema) => schema.required('Please Enter Marks per Question'),
                otherwise: (schema) => schema.notRequired(),
            }),
            totalTests: Yup.number().required("Please Enter Total Tests"),

            duration: Yup.number().required("Please Enter Duration"),
            selectedPlanCategory: Yup.object().required("Please select Plan Board Category"),
            selectedTotalQuestions: Yup.object().required("Please Select Total Questions"),

        }),
        onSubmit: async (values) => {

            console.log(values, 'submit values')

            setSubmitbtn(true);
            setLoading(true);

            var isPlanClone = localStorage.getItem('isPlanClone');
            const data =
            {
                "user_id": Number(user.uid),
                "plan_id": isPlanClone == 1 ? 0 : Number(spid),
                "plan_name": values.planName,
                "category_id": Number(values.selectedPlanCategory?.value),
                "total_question_id": Number(values.selectedTotalQuestions?.value),
                "mark_per_question": values.marks? values.marks : 0,
                "test_duration": values.duration,
                "total_marks": values.totalMarks? values.totalMarks : 0,
                "no_of_tests": values.totalTests,
                "validity_in_days": Number(values.validity),
                "amount": Number(values.amount),
                "plan_status": status ? 1 : 2,
                "published_status": publishStatus ? 7 : 6,
                "process_type": spid == 0 || isPlanClone == '1' ? 'save' : 'update',
            }
            if(publishStatus == true && status == false && subscriptionCount > 0){
                setPublishContent(constants.modalText.INACTIVEPLAN)
                setPublishModal(true);
                return
            }
            else{
                saveSubscription(data);
            }






        },
    });


    useEffect(() => {

        validation.resetForm();
        getmasterdatalistapi()
    }, []);


    async function editLoadPlan(varspid) {
        setLoading(true);
        const user = getLoggedInUser()
        var data = {
            user_id: Number(user.uid),
            plan_id: Number(varspid)
        }
        const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } }
        const response1 = await axios.post(url.BASE_URL + 'subscriptionplan/editLoadPlan', data, config)
        if (response1 && response1.statusFlag === 3) { // user validation
            setLoading(false);
            toast.error(response1.message, { autoClose: 2000 });
            localStorage.removeItem("authUser");
            sessionStorage.removeItem("SESSION_KEY")
            window.location.reload()
            return
        }
        if (response1?.data?.body?.status === '401' || response1?.data?.body?.status === 401) {
            setLoading(false);
            const refresh = await getRefreshToken() // Calling refreshToken if accessToken Expired
            if (refresh) {
                if (Number(refresh) === constants.invalidRefreshToken) {
                    logoutUser()
                } else {
                    await editLoadPlan(stid) // calling same function again getting refresh token
                }
            }
        }
        if (response1 && response1.data && response1.data.body && response1.data.body.list?.length > 0) {
            var respData = response1.data.body.list[0];
            setLoading(false);
            validation.setFieldValue("planName", respData?.plan_name)
            validation.setFieldValue("marks", respData?.mark_per_question)
            validation.setFieldValue("duration", respData?.test_duration)
            validation.setFieldValue("totalMarks", respData?.total_marks)
            validation.setFieldValue("totalTests", respData?.no_of_tests)
            validation.setFieldValue("validity", respData?.validity_in_days)
            validation.setFieldValue("amount", respData?.amount)
            var activeStatus = respData?.plan_status == 1 ? true : false;
            var publishStatus = respData?.published_status == 6 ? false : true;
            setstatus(activeStatus);
            setMarks(respData?.mark_per_question);
           
            setPublishStatus(publishStatus);
            setEditPublishStatus(publishStatus)
            setSubscriptionCount(respData?.subscription_count)
            setIsTestSeries(respData?.category_id == constants.subscriptionCategory.Testseries ? true : false)
            validation.setFieldValue("selectedPlanCategory", {
                label: respData?.category_name,
                value: respData?.category_id
            })
            validation.setFieldValue("selectedTotalQuestions", {
                label: respData?.total_questions,
                value: respData?.total_question_id
            })
            let selectedQue = {
                label: respData?.total_questions,
                value: respData?.total_question_id
            };
            setSelectedTotalQuestions(selectedQue);
            setLoading(false);
        }

    }


    const saveSubscription = async (data) => {
        var config;
        setInitialSubmitState(true);
        setLoading(true);
        // if ((langArr.length > 1 && contentFilesArr.length > 1) || (langArr.length == 1 && contentFilesArr.length == 1)) {
        config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } }
        var response1 = await axios.post(url.BASE_URL + 'subscriptionplan/setSubscriptionPlan', data, config)
        if (response1 && response1.statusFlag === 3) {

            setLoading(false)
            setInitialSubmitState(false);
            // user validation
            toast.error(response1.message, { autoClose: 2000 });
            localStorage.removeItem("authUser");
            sessionStorage.removeItem("SESSION_KEY")
            window.location.reload()
            return
        }
        if (response1?.data?.body?.status === '401' || response1?.data?.body?.status === 401) {
            setLoading(false);
            setInitialSubmitState(false);

            const refresh = await getRefreshToken() // Calling refreshToken if accessToken Expired
            if (refresh) {
                if (Number(refresh) === constants.invalidRefreshToken) {
                    logoutUser()
                } else {
                    saveSubscription(data) // calling same function again getting refresh token
                }
            }
        }

        if (response1 && response1.data && response1.data.body?.statusFlag == 3) {
            setLoading(false)
            setInitialSubmitState(false);
            // user validation
            // toast.error(response1.message, { autoClose: 2000 });
            toast.error(response1.data.body.message, { autoClose: 2000 });
            return
        }
        if (response1 && response1.data && response1.data.body && response1.data.body?.statusFlag == 1) {

            setLoading(false)
            setInitialSubmitState(false);
            validation.resetForm();
            toast.success(response1.data.body.message, { autoClose: 2000 });
            navigate(
                            `/list-subscriptionplan`
                        )
     
        } else {
            setLoading(false)
            setInitialSubmitState(false);
            if (response1.data.body.message) {

                toast.error(response1.data.body.message, { autoClose: 2000 });
                // if (Number(localStorage.getItem('isPlanClone')) === 3) {
                //     navigate(
                //         `/list-studymaterial-approval`
                //     )
                // } else {
                //     navigate(
                //         `/list-studymaterial`
                //     )
                // }
            } else {

            }
        }
    }

    const getmasterdatalistapi = async () => {
        try {
            setLoading(true);

            const data = { user_id: Number(user.uid) }
            const config = { headers: { authorization: 'Bearer '.concat(user.accessToken) } }
            const response1 = await axios.post(url.BASE_URL + 'subscriptionplan/getSPMaster', data, config)
            setLoading(false);

            if (response1 && response1.data && response1.data && response1.data.status === 200) {


                setPlanCategory(response1?.data?.body?.subscriptionCategory)
                setTotalQuestions(response1?.data?.body?.totalQuestions)


                if (response1?.data?.body?.status === '401' || response1?.data?.body?.status === 401) {
                    const refresh = await getRefreshToken() // Calling refreshToken if accessToken Expired
                    if (refresh) {
                        if (Number(refresh) === constants.invalidRefreshToken) {
                            logoutUser()
                        } else {
                            await getmasterdatalistapi(qid) // calling same function again getting refresh token
                        }
                    }
                }
            }
        }
        catch (e) {
            console.log(e, 'e')
        }


    }
    const handleHideMarks = (selectedOption) => {
        if (selectedOption && selectedOption.value === constants.subscriptionCategory.Testseries) { 
            setIsTestSeries(true); 
        } else {
            setIsTestSeries(false); 
              }
    }
    const handleConfirmPlan = async () => {
        const data =
        {
            "user_id": Number(user.uid),
            "plan_id": isPlanClone == 1 ? 0 : Number(spid),
            "plan_name": validation.values.planName,
            "category_id": Number(validation.values.selectedPlanCategory?.value),
            "total_question_id": Number(validation.values.selectedTotalQuestions?.value),
            "mark_per_question": validation.values.marks? validation.values.marks : 0,
            "test_duration": validation.values.duration,
            "total_marks": validation.values.totalMarks? validation.values.totalMarks : 0,
            "no_of_tests": validation.values.totalTests,
            "validity_in_days": Number(validation.values.validity),
            "amount": Number(validation.values.amount),
            "plan_status": status ? 1 : 2,
            "published_status": publishStatus ? 7 : 6,
            "process_type": spid == 0 || isPlanClone == '1' ? 'save' : 'update',
        }
            saveSubscription(data);
    
    }
    const handleClear = (category) => {
        if(category.value>0){
            validation.setFieldValue("marks", "");
            validation.setFieldValue("duration", "");
            validation.setFieldValue("totalMarks", "")
            validation.setFieldValue("totalTests", null);
            validation.setFieldValue("validity", "");
            validation.setFieldValue("amount", "");
            validation.setFieldValue("selectedTotalQuestions", null);
        }
    }

    const customStyles = {
        option: (styles, state, data) => { // fixed
            return {
                ...styles,
                backgroundColor: state.isDisabled
                    ? undefined
                    : state.isSelected
                        ? '#a6b0cf57'
                        : state.isFocused
                            ? '#556ee6'
                            : 'white',

                color: state.isDisabled
                    ? '#ccc'
                    : state.isSelected
                        ? 'black'
                        : state.isFocused
                            ? 'white'
                            : 'black',

                cursor: state.isDisabled ? 'not-allowed' : 'default',

                ':active': {
                    ...styles[':active'],
                    backgroundColor: !state.isDisabled
                        ? state.isSelected
                            ? '#556ee6'
                            : '#556ee6'
                        : undefined,
                },
                fontWeight: state.value && Number(state.value.split('-')[1]) !== 0 ? '' : '600'
            };
        }
    };


    return (

        <React.Fragment>
            <PublishModal
                    show={publishModal}
                    content={publishContent}
                    onPublishClick={handleConfirmPlan}
                    onCloseClick={() => {
                        setPublishModal(false);
                    }}
                  />
            <ToastContainer />
          {  isLoading?  <Spinners setLoading={setLoading} />:'' }
            <div className="page-content">
                <Container fluid={true}>
                    {/* <Breadcrumbs title="Exam Blue Print" breadcrumbItem="Create Blue Print" /> */}

                    <Row>
                        <Col lg="12">
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                }}
                            >
                                <Card className="crd-min-ht" style={{ padding: 16, marginLeft: '24%', width: '50%' }}>
                                    <CardBody>

                                        <form>
                                            <Row>
                                                <Col lg="12">
                                                    <Row>
                                                        {/* <Col lg="3">
                                                    </Col> */}
                                                        <Col lg="6">
                                                            <div className="mb-3">
                                                                <Label>Subscription Plan Name<span style={{ color: 'red' }}>*</span></Label>
                                                                <Input
                                                                    name="planName"
                                                                    type="text"
                                                                    // maxLength={constants.textboxLength.c_name}
                                                                    placeholder="Subscription Name"
                                                                    validate={{
                                                                        required: { value: true },
                                                                    }}
                                                                    onChange={validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    //  defaultValue={isPlanClone === '1' ? "" : validation.values.configurationName}
                                                                    value={validation.values.planName}
                                                                    invalid={
                                                                        validation.touched.planName && validation.errors.planName ? true : false
                                                                    }
                                                                    innerRef={confref}
                                                                    disabled={editPublishStatus}
                                                                    autoComplete="off"

                                                                />
                                                                {validation.touched.planName && validation.errors.planName ? (
                                                                    <FormFeedback type="invalid">{validation.errors.planName}</FormFeedback>
                                                                ) : null}
                                                            </div>

                                                            <div className="mb-3">
                                                                <Label>Subscription Category<span style={{ color: 'red' }}>*</span></Label>
                                                                <Select
                                                                    value={validation.values.selectedPlanCategory}
                                                                    onChange={(selectedOption) => {
                                                                        validation.setFieldValue("selectedPlanCategory", selectedOption);
                                                                        handleClear(selectedOption);

                                                                        // setselectePlanCategory(selectedOption);
                                                                        handleHideMarks(selectedOption)

                                                                    }}
                                                                    options={plancategory.map((option) => ({
                                                                        label: option.label,
                                                                        value: option.id,
                                                                    }))}
                                                                    className={`select2-selection ${validation.touched.selectedPlanCategory && validation.errors.selectedPlanCategory ? 'is-invalid' : ''}`}
                                                                    isDisabled={editPublishStatus}
                                                                />
                                                                {validation.touched.selectedPlanCategory && validation.errors.selectedPlanCategory ? (
                                                                    <div className="invalid-feedback">{validation.errors.selectedPlanCategory}</div>
                                                                ) : null}
                                                            </div>

                                                            <div className="mb-3">
                                                                <Label>Validity(Days)<span style={{ color: 'red' }}>*</span></Label>
                                                                <Input
                                                                    className="rightAlignText"
                                                                    disabled={editPublishStatus}
                                                                    name="validity"
                                                                    type="number"
                                                                    min="1"
                                                                    max="999"
                                                                    onChange={(e) => {
                                                                        let value = e.target.value;
                                                                        if (value.length > 3) {
                                                                            value = value.slice(0, 3);
                                                                        }
                                                                        if (parseInt(value) > 999) {
                                                                            value = "999";
                                                                        }
                                                                        e.target.value = value;
                                                                        validation.handleChange(e);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    onKeyPress={(e) => {
                                                                        if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onPaste={(e) => {
                                                                        e.preventDefault();
                                                                        const pastedText = e.clipboardData.getData('text');
                                                                        let pastedValue = parseFloat(pastedText);
                                                                        if (isNaN(pastedValue) || pastedValue < 0) {
                                                                            pastedValue = "";
                                                                        } else if (pastedValue > 999) {
                                                                            pastedValue = 999;
                                                                        }
                                                                        e.target.value = pastedValue.toString().slice(0, 3);
                                                                        validation.handleChange(e);
                                                                    }}
                                                                    value={validation.values.validity || ""}
                                                                    invalid={validation.touched.validity && validation.errors.validity ? true : false}
                                                                />
                                                                {validation.touched.validity && validation.errors.validity ? (
                                                                    <FormFeedback type="invalid">{validation.errors.validity}</FormFeedback>
                                                                ) : null}
                                                            </div>

                                                            <div className="mb-3">
                                                                <Label>Subscription Amount(Rs.)<span style={{ color: 'red' }}>*</span></Label>
                                                                <Input
                                                                    className="rightAlignText"
                                                                    disabled={editPublishStatus}
                                                                    name="amount"
                                                                    type="number"
                                                                    min="1"
                                                                    max="999999"
                                                                    onChange={(e) => {
                                                                        let value = e.target.value;
                                                                        if (value.length > 6) {
                                                                            value = value.slice(0, 6);
                                                                        }
                                                                        if (parseInt(value) > 999999) {
                                                                            value = "999999";
                                                                        }
                                                                        e.target.value = value;
                                                                        validation.handleChange(e);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    onKeyPress={(e) => {
                                                                        if (e.key === '-' || e.key === 'e') {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onPaste={(e) => {
                                                                        e.preventDefault();
                                                                        const pastedText = e.clipboardData.getData('text');
                                                                        let pastedValue = parseFloat(pastedText);
                                                                        if (isNaN(pastedValue) || pastedValue < 0) {
                                                                            pastedValue = "";
                                                                        } else if (pastedValue > 999999) {
                                                                            pastedValue = 999999;
                                                                        }
                                                                        e.target.value = pastedValue.toString().slice(0, 6);
                                                                        validation.handleChange(e);
                                                                    }}
                                                                    value={validation.values.amount || ""}
                                                                    invalid={validation.touched.amount && validation.errors.amount ? true : false}
                                                                />
                                                                {validation.touched.amount && validation.errors.amount ? (
                                                                    <FormFeedback type="invalid">{validation.errors.amount}</FormFeedback>
                                                                ) : null}
                                                            </div>




                                                            <div className="mb-3">
                                                            {spid > 0 ?
                                                                <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                               
                                                                    <div className="col-md-6" >
                                                                        <Label>Status</Label>
                                                                        <div className="square-switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                id="statusToggle"
                                                                                className="switch switch-info"
                                                                                checked={status}
                                                                                onClick={() => setstatus(!status)}
                                                                            />
                                                                            <label htmlFor="statusToggle" data-on-label="Active" data-off-label="Inactive" />
                                                                        </div>
                                                                    </div> 
                                                                    <div className="col-md-6" >
                                                                        <Label>Publish</Label>
                                                                        <div className="square-switch">
                                                                            <input
                                                                                type="checkbox"
                                                                                id="publishToggle"
                                                                                className="switch switch-info"
                                                                                checked={publishStatus}
                                                                                onClick={() => setPublishStatus(!publishStatus)}
                                                                                disabled={editPublishStatus}
                                                                            />
                                                                            <label htmlFor="publishToggle" data-on-label="Yes" data-off-label="No" />
                                                                        </div>
                                                                    </div>
                                                                </Row>:null}
                                                            </div>




                                                        </Col>
                                                        <Col lg="6">
                                                   
                                                            <div className="mb-3">
                                                                <Label>
                                                                    Total Questions<span style={{ color: 'red' }}>*</span>
                                                                </Label>
                                                                <Select
                                                                    value={validation.values.selectedTotalQuestions}
                                                                    isDisabled={editPublishStatus}
                                                                    onChange={
                                                                        (selectedOption) => {
                                                                            validation.setFieldValue("selectedTotalQuestions", selectedOption);
                                                                             setSelectedTotalQuestions(selectedOption);


                                                                        }
                                                                    }


                                                                    // handleSelectTotalMarks}
                                                                    options={totalquestions.map(option => ({
                                                                        label: option.label,
                                                                        value: option.id,
                                                                    }))}
                                                                    styles={customStyles}
                                                                    className={`select2-selection ${validation.touched.selectedTotalQuestions && validation.errors.selectedTotalQuestions ? 'is-invalid' : ''}`}
                                                                />
                                                                {validation.touched.selectedTotalQuestions && validation.errors.selectedTotalQuestions ? (
                                                                    <FormFeedback type="invalid">{validation.errors.selectedTotalQuestions}</FormFeedback>
                                                                ) : null}
                                                            </div>


                                                            <div className="mb-3" hidden={isTestSeries}>
                                                                <Label>Marks per Question<span style={{ color: 'red' }}>*</span></Label>
                                                                <Input
                                                                    className="rightAlignText"
                                                                    disabled={editPublishStatus}

                                                                    name="marks"
                                                                    type="number"
                                                                    min="1"
                                                                    max="999"
                                                                    onChange={(e) => {
                                                                        if(isTestSeries==false){
                                                                            let value = e.target.value;
                                                                            if (value.length > 3) {
                                                                                value = value.slice(0, 3);
                                                                            }
                                                                            if (parseInt(value) > 999) {
                                                                                value = "999";
                                                                            }
                                                                            e.target.value = value;
                                                                            validation.handleChange(e);
                                                                            setMarks(value);
                                                                        }
                                                                       
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    onKeyPress={(e) => {
                                                                        if (e.key === '-' || e.key === 'e' ) {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onPaste={(e) => {
                                                                        e.preventDefault();
                                                                        const pastedText = e.clipboardData.getData('text');
                                                                        let pastedValue = parseFloat(pastedText);
                                                                        if (isNaN(pastedValue) || pastedValue < 0) {
                                                                            pastedValue = "";
                                                                        } else if (pastedValue > 999) {
                                                                            pastedValue = 999;
                                                                        }
                                                                        e.target.value = pastedValue.toString().slice(0, 3);
                                                                        validation.handleChange(e);
                                                                    }}
                                                                    value={validation.values.marks || ""}
                                                                    invalid={validation.touched.marks && validation.errors.marks ? true : false}
                                                                />
                                                                {validation.touched.marks && validation.errors.marks ? (
                                                                    <FormFeedback type="invalid">{validation.errors.marks}</FormFeedback>
                                                                ) : null}
                                                            </div>
                                                            <div className="mb-3">
                                                                <Label>Total Marks<span style={{ color: 'red' }}>*</span></Label>
                                                                <Input
                                                                    className="rightAlignText"
                                                                    name="totalMarks"
                                                                    type="number"
                                                                    min="1"
                                                                    max="999"
                                                                    disabled={isTestSeries == false || editPublishStatus == true?true:false}
                                                                    onChange={(e) => {
                                                                        let value = e.target.value;
                                                                        if (value.length > 3) {
                                                                            value = value.slice(0, 3);
                                                                        }
                                                                        if (parseInt(value) > 999) {
                                                                            value = "999";
                                                                        }
                                                                        e.target.value = value;
                                                                        validation.handleChange(e);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    onKeyPress={(e) => {
                                                                        if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onPaste={(e) => {
                                                                        e.preventDefault();
                                                                        const pastedText = e.clipboardData.getData('text');
                                                                        let pastedValue = parseFloat(pastedText);
                                                                        if (isNaN(pastedValue) || pastedValue < 0) {
                                                                            pastedValue = "";
                                                                        } else if (pastedValue > 999) {
                                                                            pastedValue = 999;
                                                                        }
                                                                        e.target.value = pastedValue.toString().slice(0, 3);
                                                                        validation.handleChange(e);
                                                                    }}
                                                                    value={validation.values.totalMarks || ""}
                                                                    invalid={validation.touched.totalMarks && validation.errors.totalMarks ? true : false}
                                                                />
                                                                {validation.touched.totalMarks && validation.errors.totalMarks ? (
                                                                    <FormFeedback type="invalid">{validation.errors.totalMarks}</FormFeedback>
                                                                ) : null}
                                                            </div>
                                                            <div className="mb-3">
                                                                <Label>Duration(Mins)<span style={{ color: 'red' }}>*</span></Label>
                                                                <Input
                                                                    className="rightAlignText"
                                                                    disabled={editPublishStatus}
                                                                    name="duration"
                                                                    type="number"
                                                                    min="1"
                                                                    max="999"
                                                                    onChange={(e) => {
                                                                        let value = e.target.value;
                                                                        if (value.length > 3) {
                                                                            value = value.slice(0, 3);
                                                                        }
                                                                        if (parseInt(value) > 999) {
                                                                            value = "999";
                                                                        }
                                                                        e.target.value = value;
                                                                        validation.handleChange(e);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    onKeyPress={(e) => {
                                                                        if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onPaste={(e) => {
                                                                        e.preventDefault();
                                                                        const pastedText = e.clipboardData.getData('text');
                                                                        let pastedValue = parseFloat(pastedText);
                                                                        if (isNaN(pastedValue) || pastedValue < 0) {
                                                                            pastedValue = "";
                                                                        } else if (pastedValue > 999) {
                                                                            pastedValue = 999;
                                                                        }
                                                                        e.target.value = pastedValue.toString().slice(0, 3);
                                                                        validation.handleChange(e);
                                                                    }}
                                                                    value={validation.values.duration || ""}
                                                                    invalid={validation.touched.duration && validation.errors.duration ? true : false}
                                                                />
                                                                {validation.touched.duration && validation.errors.duration ? (
                                                                    <FormFeedback type="invalid">{validation.errors.duration}</FormFeedback>
                                                                ) : null}
                                                            </div>
                                                       
                                                            <div className="mb-3">
                                                                <Label>No. of Tests<span style={{ color: 'red' }}>*</span></Label>
                                                                <Input
                                                                    className="rightAlignText"
                                                                    disabled={editPublishStatus}
                                                                    name="totalTests"
                                                                    type="number"
                                                                    min="1"
                                                                    max="999"
                                                                    onChange={(e) => {
                                                                        let value = e.target.value;
                                                                        if (value.length > 3) {
                                                                            value = value.slice(0, 3);
                                                                        }
                                                                        if (parseInt(value) > 999) {
                                                                            value = "999";
                                                                        }
                                                                        e.target.value = value;
                                                                        validation.handleChange(e);
                                                                    }}
                                                                    onBlur={validation.handleBlur}
                                                                    onKeyPress={(e) => {
                                                                        if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                    onPaste={(e) => {
                                                                        e.preventDefault();
                                                                        const pastedText = e.clipboardData.getData('text');
                                                                        let pastedValue = parseFloat(pastedText);
                                                                        if (isNaN(pastedValue) || pastedValue < 0) {
                                                                            pastedValue = "";
                                                                        } else if (pastedValue > 999) {
                                                                            pastedValue = 999;
                                                                        }
                                                                        e.target.value = pastedValue.toString().slice(0, 3);
                                                                        validation.handleChange(e);
                                                                    }}
                                                                    value={validation.values.totalTests || ""}
                                                                    invalid={validation.touched.totalTests && validation.errors.totalTests ? true : false}
                                                                />
                                                                {validation.touched.totalTests && validation.errors.totalTests ? (
                                                                    <FormFeedback type="invalid">{validation.errors.totalTests}</FormFeedback>
                                                                ) : null}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>


                                            </Row>
                                        </form>

                                    </CardBody>
                                    {/* <CardFooter> */}

                                    <div className="text-end">
                                            <Button color="success"
                                                type="submit"
                                                className="save-user"
                                                disabled={initialSubmitState}
                                             
                                            >
                                                {spid > 0 && isPlanClone === '0' ? 'Update' : 'Save'}
                                            </Button>
                                            <button type="button" style={{ marginLeft: "10px" }}
                                                onClick={handleClose}
                                                className="btn btn-danger">Close</button>
                                        </div>

                                    {/* </CardFooter> */}

                                </Card>
                            </Form>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default CreateSubscription;
